export const appRoutes = {
  auth: '/auth',
  main: '/',
  confirm: '/confirm',
};